import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, normalizeClass as _normalizeClass } from "vue"

import { ref, toRefs } from 'vue';

// 定义组件props

export default /*@__PURE__*/_defineComponent({
  __name: 'SwipeableTable',
  props: {
  // 表格标题
  title: {
    type: String,
    default: '',
  },

  // 表格头部配置
  headers: {
    type: Array as () => Array<{
      key: string; // 数据字段名
      label: string; // 表头显示文本
      isInput?: boolean; // 是否为输入框列
      inputType?: string; // 输入框类型
      placeholder?: string; // 输入框占位文本
    }>,
    required: true,
  },

  // 数据源
  dataSource: {
    type: Array,
    required: true,
  },

  // 数据项的唯一标识字段
  keyField: {
    type: String,
    default: 'id',
  },

  // 空状态提示文本
  emptyText: {
    type: String,
    default: '暂无数据',
  },

  showDeleteButton: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  'delete', // 删除事件
  'inputChange', // 输入框变化事件
  'clickEdit', // 点击进入编辑页面
],
  setup(__props, { emit: __emit }) {

const props = __props;

// 定义组件事件
const emits = __emit;

// 处理输入框变化
const handleInputChange = (item: any, field: string) => {
  // 触发输入变化事件，通知父组件
  emits('inputChange', item, field);
};

// 点击事件
const toClickEdit = (item: any) => {
  // 触发输入变化事件，通知父组件
  emits('clickEdit', item);
};

// 处理删除操作
const handleDelete = (item: any) => {
  // 触发删除事件，通知父组件
  emits('delete', item);
};

return (_ctx: any,_cache: any) => {
  const _component_taro_view = _resolveComponent("taro-view")!
  const _component_nut_input = _resolveComponent("nut-input")!
  const _component_taro_text = _resolveComponent("taro-text")!
  const _component_taro_button = _resolveComponent("taro-button")!
  const _component_nut_swipe = _resolveComponent("nut-swipe")!

  return (_openBlock(), _createBlock(_component_taro_view, { class: "swipeable-table-container" }, {
    default: _withCtx(() => [
      (__props.title)
        ? (_openBlock(), _createBlock(_component_taro_view, {
            key: 0,
            class: "table-title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_taro_view, { class: "table-header" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header, index) => {
            return (_openBlock(), _createBlock(_component_taro_view, {
              class: "table-col",
              key: index
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(header.label), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_taro_view, { class: "table-body" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSource, (item, index) => {
            return (_openBlock(), _createBlock(_component_nut_swipe, {
              key: item[__props.keyField]
            }, _createSlots({
              default: _withCtx(() => [
                _createVNode(_component_taro_view, {
                  class: "table-row",
                  onClick: ($event: any) => (toClickEdit(item))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header, colIndex) => {
                      return (_openBlock(), _createBlock(_component_taro_view, {
                        class: "table-col",
                        key: colIndex
                      }, {
                        default: _withCtx(() => [
                          (header.isInput)
                            ? (_openBlock(), _createBlock(_component_nut_input, {
                                key: 0,
                                modelValue: item[header.key],
                                "onUpdate:modelValue": ($event: any) => ((item[header.key]) = $event),
                                type: header.inputType || 'text',
                                placeholder: header.placeholder ? header.placeholder : '',
                                onChange: ($event: any) => (handleInputChange(item, header.key)),
                                class: "input-field",
                                "input-align": "center"
                              }, _createSlots({ _: 2 }, [
                                (header.right)
                                  ? {
                                      name: "right",
                                      fn: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(header.right), 1)
                                      ]),
                                      key: "0"
                                    }
                                  : undefined
                              ]), 1032, ["modelValue", "onUpdate:modelValue", "type", "placeholder", "onChange"]))
                            : (header?.iconType == 'arrow')
                              ? (_openBlock(), _createBlock(_component_taro_view, {
                                  key: 1,
                                  class: "change-cell"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_taro_text, {
                                      class: _normalizeClass([
                    'arrow-icon',
                    String(item[header.key]).startsWith('-')
                      ? 'down-arrow'
                      : 'up-arrow',
                  ])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(String(item[header.key]).startsWith('-') ? '▼' : '▲'), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"]),
                                    _createVNode(_component_taro_text, { class: "change-value" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(Math.abs(Number(item[header.key])) || 0), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(item[header.key]), 1)
                                ], 64))
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, [
              (__props.showDeleteButton)
                ? {
                    name: "right",
                    fn: _withCtx(() => [
                      _createVNode(_component_taro_button, {
                        onClick: ($event: any) => (handleDelete(item)),
                        class: "delete-btn"
                      }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode("删除")
                        ])),
                        _: 2,
                        __: [0]
                      }, 1032, ["onClick"])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1024))
          }), 128))
        ]),
        _: 1
      }),
      (__props.dataSource.length === 0)
        ? (_openBlock(), _createBlock(_component_taro_view, {
            key: 1,
            class: "empty-state"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.emptyText || '暂无数据'), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})